var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQrCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "QR_Code",
    "data-name": "QR Code",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1316",
    "data-name": "Ret\\xE2ngulo 1316",
    width: 2.791,
    height: 6.698,
    transform: "translate(4.744 0.837)",
    fill: "#0080fc",
    opacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1317",
    "data-name": "Ret\\xE2ngulo 1317",
    width: 2.791,
    height: 6.698,
    transform: "translate(20.372 0.837)",
    fill: "#0080fc",
    opacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1318",
    "data-name": "Ret\\xE2ngulo 1318",
    width: 2.791,
    height: 6.698,
    transform: "translate(20.372 16.465)",
    fill: "#0080fc",
    opacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5049",
    "data-name": "Caminho 5049",
    d: "M7.535,8.372H.837A.837.837,0,0,1,0,7.535V.837A.837.837,0,0,1,.837,0h6.7a.837.837,0,0,1,.837.837v6.7A.837.837,0,0,1,7.535,8.372ZM1.674,6.7H6.7V1.674H1.674Z",
    fill: "#0080fc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5050",
    "data-name": "Caminho 5050",
    d: "M6.837,7.683a.837.837,0,0,1-.592-.246.812.812,0,0,1-.106-.128,1.2,1.2,0,0,1-.078-.145,1.277,1.277,0,0,1-.045-.156A.758.758,0,0,1,6,6.846a.846.846,0,0,1,.246-.592.864.864,0,0,1,1.183,0,.846.846,0,0,1,.246.592.758.758,0,0,1-.017.162,1.277,1.277,0,0,1-.045.156,1.2,1.2,0,0,1-.078.145.812.812,0,0,1-.106.128.837.837,0,0,1-.592.246Z",
    transform: "translate(-2.651 -2.66)",
    fill: "#0080fc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5051",
    "data-name": "Caminho 5051",
    d: "M35.535,8.372h-6.7A.837.837,0,0,1,28,7.535V.837A.837.837,0,0,1,28.837,0h6.7a.837.837,0,0,1,.837.837v6.7A.837.837,0,0,1,35.535,8.372ZM29.674,6.7H34.7V1.674H29.674Z",
    transform: "translate(-12.372 0)",
    fill: "#0080fc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5052",
    "data-name": "Caminho 5052",
    d: "M34.837,7.683a.837.837,0,0,1-.592-.246.811.811,0,0,1-.106-.128,1.2,1.2,0,0,1-.078-.145,1.277,1.277,0,0,1-.045-.156A.758.758,0,0,1,34,6.846a.846.846,0,0,1,.246-.592.864.864,0,0,1,1.183,0,.846.846,0,0,1,.246.592.758.758,0,0,1-.017.162,1.278,1.278,0,0,1-.045.156,1.2,1.2,0,0,1-.078.145.811.811,0,0,1-.106.128A.837.837,0,0,1,34.837,7.683Z",
    transform: "translate(-15.023 -2.66)",
    fill: "#0080fc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5053",
    "data-name": "Caminho 5053",
    d: "M35.535,36.372h-6.7A.837.837,0,0,1,28,35.535v-6.7A.837.837,0,0,1,28.837,28h6.7a.837.837,0,0,1,.837.837v6.7A.837.837,0,0,1,35.535,36.372ZM29.674,34.7H34.7V29.674H29.674Z",
    transform: "translate(-12.372 -12.372)",
    fill: "#0080fc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5054",
    "data-name": "Caminho 5054",
    d: "M34.838,35.683a.837.837,0,0,1-.592-1.429.864.864,0,0,1,1.183,0,.837.837,0,0,1-.592,1.429Z",
    transform: "translate(-15.024 -15.032)",
    fill: "#0080fc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5055",
    "data-name": "Caminho 5055",
    d: "M26.977,12.837h-6.14A.837.837,0,0,1,20,12V.837a.837.837,0,1,1,1.674,0V11.163h5.3a.837.837,0,1,1,0,1.674Z",
    transform: "translate(-8.837 0)",
    fill: "#0080fc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5056",
    "data-name": "Caminho 5056",
    d: "M39.512,21.674H37.837a.837.837,0,1,1,0-1.674h1.674a.837.837,0,1,1,0,1.674Z",
    transform: "translate(-16.349 -8.837)",
    fill: "#0080fc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5057",
    "data-name": "Caminho 5057",
    d: "M17.744,32.256a.837.837,0,0,1-.837-.837V27.674h-3.07a.837.837,0,1,1,0-1.674h3.907a.837.837,0,0,1,.837.837v4.581A.837.837,0,0,1,17.744,32.256Z",
    transform: "translate(-5.744 -11.488)",
    fill: "#0080fc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5058",
    "data-name": "Caminho 5058",
    d: "M20.837,41.683a.846.846,0,0,1-.592-.246A.837.837,0,0,1,20,40.846a.846.846,0,0,1,.246-.592.864.864,0,0,1,1.183,0,.837.837,0,0,1-.592,1.429Z",
    transform: "translate(-8.837 -17.683)",
    fill: "#0080fc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5059",
    "data-name": "Caminho 5059",
    d: "M7.535,20.791H.837a.837.837,0,0,1,0-1.674H6.7v-.279a.837.837,0,0,1,1.674,0v1.116A.837.837,0,0,1,7.535,20.791Z",
    transform: "translate(0 -7.953)",
    fill: "#0080fc"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5060",
    "data-name": "Caminho 5060",
    d: "M8.651,41.674H.837A.837.837,0,0,1,.837,40H8.651a.837.837,0,0,1,0,1.674Z",
    transform: "translate(0 -17.674)",
    fill: "#0080fc"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5061",
    "data-name": "Caminho 5061",
    d: "M8.837,38.14A.837.837,0,0,1,8,37.3V32.837a.837.837,0,1,1,1.674,0V37.3A.837.837,0,0,1,8.837,38.14Z",
    transform: "translate(-3.535 -14.14)",
    fill: "#0080fc"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5062",
    "data-name": "Caminho 5062",
    d: "M11.628,35.674H8.837a.837.837,0,1,1,0-1.674h2.791a.837.837,0,1,1,0,1.674Z",
    transform: "translate(-3.535 -15.023)",
    fill: "#0080fc"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5063",
    "data-name": "Caminho 5063",
    d: "M.837,32.14A.837.837,0,0,1,0,31.3V26.837A.837.837,0,0,1,.837,26H3.628a.837.837,0,0,1,0,1.674H1.674V31.3a.837.837,0,0,1-.837.837Z",
    transform: "translate(0 -11.488)",
    fill: "#0080fc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/QR Code.41174bc9.svg";
export { ForwardRef as ReactComponent };